<template>
  <div class="main">
    <div class="site-chart">
      <p class="t12 centerS">
        <span>遥感云计算申请次数</span>
        <span class="all-p">申请总次数：
          <span>{{num1}}</span>
          次
        </span>
      </p>
      <Query @updata="updata1"/>
      <div id="syschart" class="chart1"></div>
    </div>
    <div class="site-chart">
      <p class="t12 centerS">
        <span>遥感云计算申请时长统计</span>
        <span class="all-p">申请总时长：
          <span>{{num2}}</span>
          小时
        </span>
      </p>
      <Query @updata="updata2"/>
      <div id="chart2" class="chart1"></div>
    </div>
    <div class="site-chart">
      <p class="t12 centerS">
        <span>卫星申请次数统计</span>
        <span class="all-p">申请总次数：
          <span>{{num3}}</span>
          次
        </span>
      </p>
      <Query @updata="updata3"/>
      <div id="satellite" class="chart1"></div>
    </div>
  </div>
</template>

<script>
var date = new Date();
import Query from "./query.vue"
import * as echarts from 'echarts';
import {
  getJupyterLog,
  getApplyTime,
  getSatelliteApplyCount
} from "@/api/log/index"
export default {
  components:{
    Query
  },
  data(){
    return{
      chartDom1:null,
      chartDom2:null,
      chartDom3:null,
      num1:0,
      num2:0,
      num3:0,
      chartForm1:{
        timeType:1,
        month:'',
        year:date.getFullYear().toString()
      },
      chartForm2:{
        timeType:1,
        month:'',
        year:date.getFullYear().toString()
      },
      chartForm3:{
        timeType:1,
        month:'',
        year:date.getFullYear().toString()
      }
    }
  },
  created(){
    this.getall1()
    this.getall2()
    this.getall3()
  },
  mounted(){
    this.initChart1()
    this.initChart2()
    this.initChart3()
    //数据
    this.getChart1Data()
    this.getChart2Data()
    this.getChart3Data()
  },
  methods:{
    async getall1(){
      let res = await getJupyterLog({timeType:-1})
      this.num1 = res[0].y
    },
    async getall2(){
      let res = await getApplyTime({timeType:-1})
      this.num2 = res[0].y
    },
    async getall3(){
      let res = await getSatelliteApplyCount({timeType:-1})
      this.num3 = res[0].y
    },

    async getChart1Data(){
      let res = await getJupyterLog(this.chartForm1)
      let option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow',
            label: {
              show: true
            }
          },
          formatter : function(params) {
            return params[0].name + '/' + params[0].data + '次'
          }
        },
        color: ['#5DC0FF'],
        xAxis: {
          type: 'category',
          data: res.map(item => {return item.x})
        },
        yAxis: {
          name:'单位：次',
          type: 'value'
        },
        series: [
          {
            data: res.map(item => {return item.y}),
            type: 'bar',
            barWidth : 12,
            itemStyle:{
              normal:{
                barBorderRadius:[50,50,50,50]
              }
            }
          }
        ]
      };
      this.chartDom1.setOption(option)
    },
    async getChart2Data(){
      let res = await getApplyTime(this.chartForm2)
      let option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow',
            label: {
              show: true
            }
          },
          formatter : function(params) {
            return params[0].name + '/' + params[0].data + '小时'
          }
        },
        color: ['#5DC0FF'],
        xAxis: {
          type: 'category',
          data: res.map(item => {return item.x})
        },
        yAxis: {
          name:'单位：小时',
          type: 'value'
        },
        series: [
          {
            data: res.map(item => {return item.y}),
            type: 'bar',
            barWidth : 12,
            itemStyle:{
              normal:{
                barBorderRadius:[50,50,50,50]
              }
            }
          }
        ]
      };
      this.chartDom2.setOption(option)
    },
    async getChart3Data(){
      let res = await getSatelliteApplyCount(this.chartForm3)
      let option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow',
            label: {
              show: false
            }
          },
          formatter : function(params) {
            return params[0].name + '<br/>' +'<span style="color:rgba(95, 163, 255, 1);">'+params[0].data+'<span/>' + '次'
          }
        },
        xAxis: {
          type: 'category',
          data: res.map(item => {return item.x})
        },
        yAxis: {
          name:'单位：次',
          type: 'value'
        },
        series: [
          {
            data: res.map(item => {return item.y}),
            type: 'line',
            showSymbol:false,
            lineStyle: {
                color: '#5DC0FF'
              },
            areaStyle: {normal: {
              color: new echarts.graphic.LinearGradient(
                      0, 0, 0, 1,
                      [
                          {offset: 0, color: 'rgba(93, 162, 255, 0.2)'},
                          {offset: 1, color: 'rgba(93, 192, 255, 0.1)'}
                      ]
              )
            }},
          }
        ]
      };
      this.chartDom3.setOption(option)
    },

    updata1(val){
      let key
      let q_year = ''
      let q_month = ''
      
      q_year
      q_month

      switch (val.type) {
        case 3:
          key = 0
          q_year = val.timeM?val.timeM.slice(0,4):''
          q_month = val.timeM?val.timeM.slice(5,7):''
          break;
        case 6:
          key = 1
          q_year = val.timeY?val.timeY:''
          q_month= ''
          break;
      
        default:
          key = 2
          q_year = ''
          q_month= ''
          break;
      }
      this.chartForm1 = {
        timeType:key,
        month:q_month,
        year:q_year
      }
      this.getChart1Data()
    },
    updata3(val){
      let key
      let q_year = ''
      let q_month = ''
      
      q_year
      q_month

      switch (val.type) {
        case 3:
          key = 0
          q_year = val.timeM?val.timeM.slice(0,4):''
          q_month = val.timeM?val.timeM.slice(5,7):''
          break;
        case 6:
          key = 1
          q_year = val.timeY?val.timeY:''
          q_month= ''
          break;
      
        default:
          key = 2
          q_year = ''
          q_month= ''
          break;
      }
      this.chartForm3 = {
        timeType:key,
        month:q_month,
        year:q_year
      }
      this.getChart3Data()
    },
    updata2(val){
      let key
      let q_year = ''
      let q_month = ''
      
      q_year
      q_month

      switch (val.type) {
        case 3:
          key = 0
          q_year = val.timeM?val.timeM.slice(0,4):''
          q_month = val.timeM?val.timeM.slice(5,7):''
          break;
        case 6:
          key = 1
          q_year = val.timeY?val.timeY:''
          q_month= ''
          break;
      
        default:
          key = 2
          q_year = ''
          q_month= ''
          break;
      }
      this.chartForm2 = {
        timeType:key,
        month:q_month,
        year:q_year
      }
      this.getChart2Data()
    },

    initChart1(){
      this.chartDom1 = echarts.init(document.getElementById('syschart'));
      let option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow',
            label: {
              show: true
            }
          },
          formatter : function(params) {
            return params[0].name + '/' + params[0].data + '次'
          }
        },
        color: ['#5DC0FF'],
        xAxis: {
          type: 'category',
          data: []
        },
        yAxis: {
          name:'单位：次',
          type: 'value'
        },
        series: [
          {
            data: [],
            type: 'bar',
            barWidth : 12,
            itemStyle:{
              normal:{
                barBorderRadius:[50,50,50,50]
              }
            }
          }
        ]
      };
      this.chartDom1.setOption(option)
    },
    initChart2(){
      this.chartDom2 = echarts.init(document.getElementById('chart2'));
      let option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow',
            label: {
              show: true
            }
          },
          formatter : function(params) {
            return params[0].name + '/' + params[0].data + '小时'
          }
        },
        color: ['#5DC0FF'],
        xAxis: {
          type: 'category',
          data: []
        },
        yAxis: {
          name:'单位：小时',
          type: 'value'
        },
        series: [
          {
            data: [],
            type: 'bar',
            barWidth : 12,
            itemStyle:{
              normal:{
                barBorderRadius:[50,50,50,50]
              }
            }
          }
        ]
      };
      this.chartDom2.setOption(option)
    },
    initChart3(){
      this.chartDom3 = echarts.init(document.getElementById('satellite'));
      let option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow',
            label: {
              show: false
            }
          },
          formatter : function(params) {
            return params[0].name + '<br/>' +'<span style="color:rgba(95, 163, 255, 1);">'+params[0].data+'<span/>' + '次'
          }
        },
        xAxis: {
          type: 'category',
          data: []
        },
        yAxis: {
          name:'单位：次',
          type: 'value'
        },
        series: [
          {
            data: [],
            type: 'line',
            showSymbol:false,
            lineStyle: {
                color: '#5DC0FF'
              },
            areaStyle: {normal: {
              color: new echarts.graphic.LinearGradient(
                      0, 0, 0, 1,
                      [
                          {offset: 0, color: 'rgba(93, 162, 255, 0.2)'},
                          {offset: 1, color: 'rgba(93, 192, 255, 0.1)'}
                      ]
              )
            }},
          }
        ]
      };
      this.chartDom3.setOption(option)
    },
  }
}
</script>

<style lang="scss" scoped>
.all-p{
  font-size: 14px;
  font-weight: 400;
}
.main{
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  .site-chart{
    width: 49%;
    height: 457px;
    margin-bottom: 12px;
  }
  .chart1{
    width: 100%;
    height: calc(100% - 100px);
  }
}
.t12{
  font-size: 20px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #2F2F2F;
  margin: 12px 0;
}
</style>